import { render, staticRenderFns } from "./PagamentoAssociarComprometimentos.vue?vue&type=template&id=620c7f95"
import script from "./PagamentoAssociarComprometimentos.vue?vue&type=script&lang=js"
export * from "./PagamentoAssociarComprometimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports